import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Address } from '../../models/data-model';


export type AddressFormGroup = {
    postalCode: FormControl<string>;
    city: FormControl<string>;
    countryISO: FormControl<string>;
    province: FormControl<string>;
    searchRefCode: FormControl<string>;
    line1: FormControl<string>;
    line2: FormControl<string>;
}

export type IrishCounty = {
    name: string;
}

@Injectable({
    providedIn: 'root'
})
export class Address3HelperService {

    constructor(private readonly fb: FormBuilder) { }

    createEmptyAddressFormGroup(country: string): FormGroup<AddressFormGroup> {
        const formGroup: FormGroup<AddressFormGroup> = this.fb.group({
            countryISO: [country],
            searchRefCode: [null],
            line1: [null],
            line2: [null],
            city: [null],
            postalCode: [null],
            province: [null]
        });

        return formGroup;
    }

    createPrepopulatedAddressFormGroup(address: Address): FormGroup<AddressFormGroup> {
        const formGroup: FormGroup<AddressFormGroup> = this.fb.group({
            countryISO: [address?.countryISO],
            searchRefCode: [address?.searchRefCode],
            line1: [address?.line1],
            line2: [address?.line2],
            city: [address?.city],
            postalCode: [address?.postalCode],
            province: [address?.province]
        });

        return formGroup;
    }

    resetValidators(addressFormGroup: FormGroup<AddressFormGroup>): void {
        const fields: Array<keyof AddressFormGroup> = ["line1", "line2", "city", "postalCode", "province"];
        fields.forEach(fieldName => {
            addressFormGroup.controls[fieldName].clearValidators();
        });
    }

    updateValidity(addressFormGroup: FormGroup<AddressFormGroup>): void {
        const fields: Array<keyof AddressFormGroup> = ["line1", "line2", "city", "postalCode", "province"];
        fields.forEach(fieldName => {
            addressFormGroup.controls[fieldName].updateValueAndValidity({ emitEvent: false });
        });
    }

    getGooglePlaceComponent(place: google.maps.places.PlaceResult, type: string, short = false): string {
        const component = place.address_components?.find(c => c.types.includes(type));
        return (short ? component?.short_name : component?.long_name) ?? "";
    }

    getIrishCounties(): Array<IrishCounty> {
        return [
            { name: "Cork" },
            { name: "Galway" },
            { name: "Mayo" },
            { name: "Donegal" },
            { name: "Kerry" },
            { name: "Tipperary" },
            { name: "Clare" },
            { name: "Limerick" },
            { name: "Roscommon" },
            { name: "Wexford" },
            { name: "Meath" },
            { name: "Kilkenny" },
            { name: "Wicklow" },
            { name: "Offaly" },
            { name: "Cavan" },
            { name: "Waterford" },
            { name: "Westmeath" },
            { name: "Sligo" },
            { name: "Laois" },
            { name: "Kildare" },
            { name: "Leitrim" },
            { name: "Monaghan" },
            { name: "Longford" },
            { name: "Dublin" },
            { name: "Carlow" },
            { name: "Louth" }
        ]
    }
}
